import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../../components/tables/tableContext/TableContext";
import { AssignedCarsNodeDataInterface } from "../../../../../redux/interfaces/fleet.interface";
import { getDateAndTime } from "../../../../../utils/dateAndTime";

export const assignedCarsNodeTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Nr. auto",
    value: "nrauto",
    minW: 125,
    withSearch: true,
  },
  {
    label: "Marca",
    value: "marca",
    minW: 125,
  },
  {
    label: "Model",
    value: "model",
    minW: 125,
  },
  {
    label: "Nod",
    value: "id_nod",
    minW: 125,
  },
  {
    label: "Data start",
    value: "data_start",
    minW: 125,
  },
];

export const getAssignedCarsNodeTableData = (
  data: AssignedCarsNodeDataInterface[],
): TableData[] =>
  data.map((item) => {
    return {
      id: item.id_flota_nod,
      crudData: item,
      data: [
        {
          title: item.nrauto,
        },
        {
          title: item.marca,
        },
        {
          title: item.model,
        },
        {
          title: item.nodNume,
        },
        {
          badges: [
            {
              badgeText: getDateAndTime(item.data_start),
              badgeColor: "light-info",
            },
          ],
        },
      ],
    };
  });
